import React from 'react'
import PropTypes from 'prop-types'

const DOWNLOAD_PATH = 'M480-336 288-528l51-51 105 105v-342h72v342l105-105 51 51-192 192ZM263.72-192Q234'
  + '-192 213-213.15T192-264v-72h72v72h432v-72h72v72q0 29.7-21.16 50.85Q725.68-192 695.96-192H263.72Z'

const DownloadIcon = ({ className = '' }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="currentColor"
    height="1em"
    viewBox="168 -816 624 624"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d={DOWNLOAD_PATH} />
  </svg>
)

DownloadIcon.propTypes = {
  className: PropTypes.string
}

DownloadIcon.defaultProps = {
  className: ''
}

export default DownloadIcon
